import React, {useState} from 'react';


import GeneralCardWithoutImage from '../GeneralCardWithoutImage';
import JsonToJSX from './JsonToJSX.jsx';


import TemplateJSON from './JSONs/Template.json'

function SRT_Archangels_LO(props) {
    
    const [step, setStep] = useState(0);

    return (
        <>
            <br />
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                <hr class="my-2" />
                <h2>Logistics Officer</h2>
                <h2>Application</h2>
                <hr class="my-4" />
            </div>
            {step === 0 && (
                <>
                    <JsonToJSX InputJSON={TemplateJSON} editMode={true} />

                </>
            )}
            
        </>
    )
}

export default SRT_Archangels_LO;